import { config } from "@/app/config";
import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import {
  getRemoteConfig,
  fetchAndActivate,
  getAll
} from "firebase/remote-config";

interface IFirebaseConfig {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  measurementId: string;
}

const firebaseConfig: IFirebaseConfig = {
  apiKey: config.apiKey,
  authDomain: config.authDomain,
  projectId: config.projectId,
  storageBucket: config.storageBucket,
  messagingSenderId: config.messagingSenderId,
  appId: config.appId,
  measurementId: config.measurementId,
};

const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);

export const getFeatureToggles = async () => {
  const remoteConfig = getRemoteConfig(app);

  remoteConfig.settings.minimumFetchIntervalMillis = 0;

  await fetchAndActivate(remoteConfig);

  const allParams = getAll(remoteConfig);
  const toggles: Record<string, boolean> = {};

  Object.keys(allParams).forEach((key) => {
    toggles[key] = allParams[key].asBoolean();
  });

  return toggles;
};
